var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-title"},[_vm._v("CA办理")]),_vm._v(" "),_c('div',{staticClass:"main-top"},[_c('ca')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }